import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import styles from '../../css/components/forms/textInput.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import TextInputHints from './TextInputHints';
import LoadingSpinner from '../common/LoadingSpinner';

export const TEXT_INPUT_STYLES = {
	STANDARD: 'standard',
	INGAME: 'ingame',
	LOGIN: 'login',
	PASSWORD_FORGOTTEN: 'passwordForgotten',
};

function TextInput({
	type, id,
	labelText = null,
	extraMargin = false,
	placeholder = null,
	style = TEXT_INPUT_STYLES.STANDARD,
	value = '',
	onChangeCallback,
	hintMessagesList = null,
	showLoadingSpinner = false,
	valid = null,
	disabled = false,
	autoComplete='off'
}) {
	const [focused, setFocused] = useState(false);
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const showValidationIndicators = onelpsParams.form && onelpsParams.form.showFieldValidationIndicators; 

	const className = `${styles.textInput} ${extraMargin ? styles.firstField : ''} ${styles[style]}`;
	let wrapperClassNames = `${styles.textInputWrapper} ${styles[onelpsParams.pageType]} ${styles[onelpsParams.gameId]}`;

	if (showValidationIndicators && value !== '' && valid === true) {
		wrapperClassNames += ` ${styles.valid}`;
	}
	
	if (showValidationIndicators && value !== '' && valid === false) {
		wrapperClassNames += ` ${styles.invalid}`;
	}

	return (
		<div className={`${styles[onelpsParams.gameId]} ${styles[onelpsParams.pageType]}`}>
			{labelText && (
				<label
					htmlFor={id}
					className={`${styles.label} ${styles[onelpsParams.gameId]} ${styles[style]}`}
				>
					{labelText}
				</label>
			)}
			{onelpsParams.form.showHints && (
				<div className={`${styles.hintWrapper} ${styles[onelpsParams.pageType]}`}>
					{hintMessagesList && hintMessagesList.length > 0 && focused && (
						<TextInputHints
							hintMessages={hintMessagesList}
							style={style}
							gameId={onelpsParams.gameId}
							pageType={onelpsParams.pageType}
						/>
					)}
				</div>
			)}			
			<div className={wrapperClassNames}>
				<input
					className={className}
					type={type}
					id={id}
					onChange={onChangeCallback}
					onFocus={() =>  setFocused(true)}
					onBlur={() => setFocused(false)}
					placeholder={placeholder}
					value={value}
					autoComplete={autoComplete}
					disabled={disabled}
				/>
				{showLoadingSpinner && (
					<LoadingSpinner
						isOnTextInput
						isOnLoginFormTextInput={style === TEXT_INPUT_STYLES.LOGIN}
					/>
				)}
			</div>
		</div>
	);
}

export default TextInput;

TextInput.propTypes = {
	type: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	labelText: PropTypes.string,
	onChangeCallback: PropTypes.func.isRequired,
	hintMessagesList: PropTypes.array,
	extraMargin: PropTypes.bool,
	placeholder: PropTypes.string,
	style: PropTypes.oneOf(Object.values(TEXT_INPUT_STYLES)),
	value: PropTypes.string,
	showLoadingSpinner: PropTypes.bool,
	valid: PropTypes.bool,
	disabled: PropTypes.bool,
	autoComplete: PropTypes.string,
};
